function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useNavigation, useNavigationState, useRoute } from "@react-navigation/native";
import { useCallback, useEffect } from "react";
import { setPersistedState, usePersistedState } from "./usePersistedState";
export function useArtifactResult(callback) {
    var setParams = useNavigation().setParams;
    var _useRoute = useRoute(), name = _useRoute.name, params = _useRoute.params;
    useEffect(function() {
        if (params === null || params === void 0 ? void 0 : params._artifactResult) {
            var artifactResult = params._artifactResult;
            setParams({
                _artifactResult: undefined
            });
            callback(artifactResult);
        }
    }, [
        setParams,
        params === null || params === void 0 ? void 0 : params._artifactResult,
        callback
    ]);
    return name;
}
export function useConversationRoute() {
    return useNavigationState(function(state) {
        return state === null || state === void 0 ? void 0 : state.routes.find(function(r) {
            return r.name === 'Conversation' || r.name === 'TestArtifactResult';
        });
    });
}
export function startArtifactRequest(artifactScreen) {
    return setPersistedState('artifactRequest', artifactScreen);
}
export function useArtifactRequest(artifactScreen, isComplete) {
    var _usePersistedState = _sliced_to_array(usePersistedState('artifactRequest', null), 1), artifactRequest = _usePersistedState[0];
    var navigation = useNavigation();
    var conversationRoute = useConversationRoute();
    var hasRequest = artifactRequest === artifactScreen && conversationRoute;
    useEffect(function() {
        if (hasRequest) {
            navigation.setOptions({
                headerBackTitleVisible: false
            });
            var remove = navigation.addListener('beforeRemove', function(e) {
                e.preventDefault();
                remove();
                setPersistedState('artifactRequest', null);
                navigation.navigate(conversationRoute === null || conversationRoute === void 0 ? void 0 : conversationRoute.name, _object_spread_props(_object_spread({}, conversationRoute === null || conversationRoute === void 0 ? void 0 : conversationRoute.params), {
                    _artifactResult: {
                        complete: isComplete
                    }
                }));
            });
            return remove;
        }
        return;
    }, [
        navigation,
        conversationRoute,
        isComplete,
        hasRequest
    ]);
    return {
        hasRequest: hasRequest,
        navigateToConversation: useCallback(function() {
            navigation.navigate(conversationRoute === null || conversationRoute === void 0 ? void 0 : conversationRoute.name, _object_spread_props(_object_spread({}, conversationRoute === null || conversationRoute === void 0 ? void 0 : conversationRoute.params), {
                _artifactResult: {
                    complete: isComplete
                }
            }));
        }, [
            navigation,
            conversationRoute,
            isComplete
        ])
    };
}
